import CategoryCard from './CategoryCard';

function CategoryGrid({ categories, onCategoryClick }) {
  return (
    <div className="category-grid">
      {categories.map(cat => (
        <CategoryCard
          key={cat.id}
          category={cat}
          onClick={() => onCategoryClick(cat)}
        />
      ))}
    </div>
  );
}

export default CategoryGrid;